import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {getPrimitive} from '@tickchak/react-share/app';

import * as css from './VideoRatingPopup.css';
import ThumbUp from '../../../assets/icons/ThumbUp';

function VideoRatingHeader() {
    const {t} = useTranslation('layout');
    const greenColor = useMemo(() => getPrimitive('greens.green400'), []);
    const redColor = useMemo(() => getPrimitive('reds.red400'), []);

    return (
        <css.tableHeader>
            <css.nameHeaderCell>
                {t('guideName')}
            </css.nameHeaderCell>
            <css.headerCell $width="98px">
                <ThumbUp fill="white" stroke={greenColor} />
                {t('greenScore')}
            </css.headerCell>
            <css.headerCell $width="91px">
                <css.rotatedIcon>
                    <ThumbUp fill="white" stroke={redColor} />
                </css.rotatedIcon>
                {t('redScore')}
            </css.headerCell>
            <css.headerCell $width="100px">
                {t('distributionChart')}
            </css.headerCell>
            <css.headerCell $width="60px">
                {t('comments')}
            </css.headerCell>
            <css.headerCell $width="80px">
                {t('views')}
            </css.headerCell>
            <css.headerCell $width="213px" $minWidth="180px">
                {t('actions')}
            </css.headerCell>
        </css.tableHeader>
    );
}

export default VideoRatingHeader;
